// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-top-home {
    position: relative;
    /* top: 30%;  */
    left: 50%;
    transform: translate(-50%, -50%); 
    width: 100%; 
    z-index: 10; 
  }
  @media (width < 2500px) and (width >= 676px) {
    .form-top-home {
      position: relative;
    top: 20%; 
    left: 50%;
    transform: translate(-50%, -50%); 
    width: 100%; 
    z-index: 10; 
    }
   
  }


  .suggestions-list {
    position: absolute;
    background-color: white;
    border: 1px solid #ccc;
    max-height: 150px;
    overflow-y: auto;
    width: 20%;
    z-index: 100;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  }
  
  .suggestion-item {
    padding: 8px;
    cursor: pointer;
  }
  

  .suggestion-item:hover {
    background-color: #f1f1f1;
  }
  
  @media (max-width: 768px) {
    .suggestions-list {
      width: 100%; /* Full width on smaller screens */
      max-width: 70%; /* Remove max-width on smaller screens */
    }
  
    .suggestion-item {
      font-size: 12px; /* Smaller font size on mobile */
    }
  }`, "",{"version":3,"sources":["webpack://./src/app/components/styles/css/search.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,WAAW;EACb;EACA;IACE;MACE,kBAAkB;IACpB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,WAAW;IACX;;EAEF;;;EAGA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,wCAAwC;EAC1C;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;;EAGA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,WAAW,EAAE,kCAAkC;MAC/C,cAAc,EAAE,wCAAwC;IAC1D;;IAEA;MACE,eAAe,EAAE,gCAAgC;IACnD;EACF","sourcesContent":[".form-top-home {\n    position: relative;\n    /* top: 30%;  */\n    left: 50%;\n    transform: translate(-50%, -50%); \n    width: 100%; \n    z-index: 10; \n  }\n  @media (width < 2500px) and (width >= 676px) {\n    .form-top-home {\n      position: relative;\n    top: 20%; \n    left: 50%;\n    transform: translate(-50%, -50%); \n    width: 100%; \n    z-index: 10; \n    }\n   \n  }\n\n\n  .suggestions-list {\n    position: absolute;\n    background-color: white;\n    border: 1px solid #ccc;\n    max-height: 150px;\n    overflow-y: auto;\n    width: 20%;\n    z-index: 100;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n  }\n  \n  .suggestion-item {\n    padding: 8px;\n    cursor: pointer;\n  }\n  \n\n  .suggestion-item:hover {\n    background-color: #f1f1f1;\n  }\n  \n  @media (max-width: 768px) {\n    .suggestions-list {\n      width: 100%; /* Full width on smaller screens */\n      max-width: 70%; /* Remove max-width on smaller screens */\n    }\n  \n    .suggestion-item {\n      font-size: 12px; /* Smaller font size on mobile */\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
